/**
 * @author Aydin Cinar
 */

(function(app) {
    app.count = (function() {
        var initialized = false;

        var limit = 0;
        var isWorked = false;
        var positionStats;

        var selectors = {
            statsSchool     : '#stats-school',
            statsCity       : '#stats-city',
            statsStudent    : '#stats-student',
            statsItems      : '.stats-items'
        };

        var schoolCount     = {score:0},
            cityCount       = {score:0},
            studentCount    = {score:0};

        var init = function() {
            initialized = true;

            app.$objs.statsScholl   = $(selectors.statsSchool);
            app.$objs.statsCity     = $(selectors.statsCity);
            app.$objs.statsStudent  = $(selectors.statsStudent);
            app.$objs.statsItems    = $(selectors.statsItems);

            bind();
        };

        var bind = function() {

            $(window).load(function () {
               findPosition();
               runOnScroll();
            });

            $(window).scroll(function() {
                runOnScroll();
            });

        };

        var findPosition  = function () {
            try {
                var pos = app.$objs.statsItems.position();
                positionStats = pos.top;
            }
            catch(err) {}
        };

        var count = function() {
            if(isWorked==false) {
                TweenLite.to(schoolCount, 1, {score:'+=80', roundProps:'score', onUpdate:updateHandler, ease:Linear.easeNone});
                TweenLite.to(cityCount, 1, {score:'+=40', roundProps:'score', onUpdate:updateHandler, ease:Linear.easeNone});
                TweenLite.to(studentCount, 1, {score:'+=10', roundProps:'score', onUpdate:updateHandler, ease:Linear.easeNone});
                isWorked= true;
            }
        };

        var updateHandler = function()  {
            app.$objs.statsScholl.text(schoolCount.score);
            app.$objs.statsCity.text(cityCount.score);
            app.$objs.statsStudent.text(studentCount.score);
        };

        var runOnScroll = function() {
            var scroll = $(document).scrollTop();

            if(scroll > positionStats) {
                if(limit===0) {
                    count();
                }
                limit++;
            }
        };


        var isInitialized = function() {
            return initialized;
        };

        return {
            init:          init,
            isInitialized: isInitialized
        };
    })();

    app.registerInit('count');
})(engelsizyasam);